import { render } from "./PlaidLinkContainer.vue?vue&type=template&id=4c37e514&ts=true"
import script from "./PlaidLinkContainer.vue?vue&type=script&lang=ts"
export * from "./PlaidLinkContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/data/front/cryptogold-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__